"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomePropertyTypeWidget = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../Types");
var React = require("react");
var reactstrap_1 = require("reactstrap");
var FalconQuestionWidgetBase_1 = require("../../FalconQuestionWidgetBase");
var InfoQuestionWrapper_1 = require("../../../components/infoQuestion/InfoQuestionWrapper");
var journey_model_1 = require("@athena-portal/journey-model");
var components_1 = require("@athena-portal/components");
var AnnualHomePropertyTypeWidget = exports.AnnualHomePropertyTypeWidget = /** @class */ (function (_super) {
    __extends(AnnualHomePropertyTypeWidget, _super);
    function AnnualHomePropertyTypeWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.propertyTypeLookup = "annualHomePropertyType";
        _this.propertySubTypeLookup = "annualHomePropertySubtype";
        _this.propertyTypeField = _this.getSetting("propertyTypeField", undefined);
        _this.propertySubTypeField = _this.getSetting("propertySubTypeField", undefined);
        if (!_this.propertyTypeField || !_this.propertySubTypeField) {
            throw Error("".concat(_this.props.question.type, " widget is missing mandatory settings"));
        }
        _this.state = {
            showPropertyTypeOtherWarning: false,
            showExistingInsuranceWarning: false,
            showPropertyKindNonSelfContainedFlatWarning: false,
            propertyType: _this.bindFromField(_this.propertyTypeField),
            propertyKind: _this.bindFromField(_this.props.question.interactionField),
            propertyTypes: [],
            propertySubTypes: [],
            subTypesLoading: false,
            hideDeclinePopUp: _this.getSetting("hideDeclinePopUp", false)
        };
        _this.toggleHidePropertyTypeOtherWarning = _this.toggleHidePropertyTypeOtherWarning.bind(_this);
        _this.toggleHidePropertyKindNonSelfContainedFlatWarning = _this.toggleHidePropertyKindNonSelfContainedFlatWarning.bind(_this);
        _this.fetchPropertyTypes = _this.fetchPropertyTypes.bind(_this);
        _this.fetchPropertySubtypes = _this.fetchPropertySubtypes.bind(_this);
        _this.renderPropertyTypes = _this.renderPropertyTypes.bind(_this);
        _this.onPropertyTypeChange = _this.onPropertyTypeChange.bind(_this);
        _this.renderPropertySubtypes = _this.renderPropertySubtypes.bind(_this);
        _this.onPropertySubTypeChange = _this.onPropertySubTypeChange.bind(_this);
        return _this;
    }
    AnnualHomePropertyTypeWidget.prototype.render = function () {
        return (React.createElement("div", { id: this.props.question.name },
            React.createElement(InfoQuestionWrapper_1.InfoQuestionWrapper, { label: "What type of property do you live in?", infoType: "collapse", info: this.renderInfoButtonText(), infoTitle: "What type of property do you live in?", hideInfoButton: this.isMtaAndDisabled() },
                this.renderInputField(),
                this.renderValidationResult())));
    };
    AnnualHomePropertyTypeWidget.prototype.renderInputField = function () {
        return (React.createElement("div", { className: "property-type-widget" },
            this.renderTypeOfPropertyQuestion(),
            !this.state.hideDeclinePopUp && this.state.showPropertyTypeOtherWarning && this.renderPropertyTypeOtherWarning(),
            !this.state.hideDeclinePopUp && this.state.showPropertyKindNonSelfContainedFlatWarning && this.renderPropertyKindNonSelfContainedFlatWarning()));
    };
    AnnualHomePropertyTypeWidget.prototype.componentDidMount = function () {
        this.fetchPropertyTypes();
        this.fetchPropertySubtypes();
    };
    AnnualHomePropertyTypeWidget.prototype.renderTypeOfPropertyQuestion = function () {
        return (React.createElement(React.Fragment, null,
            this.renderPropertyTypes(),
            this.state.showExistingInsuranceWarning && this.renderExistingInsuranceWarning(),
            this.state.propertyType && this.renderPropertySubtypes()));
    };
    AnnualHomePropertyTypeWidget.prototype.renderInfoButtonText = function () {
        return (React.createElement("div", { className: "info-button-panel font-weight-extra-light mb-3", role: "alert" },
            React.createElement("p", null,
                "If you have a dorma or chalet, please choose '",
                React.createElement("b", null, "Bungalow"),
                "'")));
    };
    AnnualHomePropertyTypeWidget.prototype.renderPropertyTypes = function () {
        var _this = this;
        var propertyTypes = this.state.propertyTypes;
        var radioButtons = [];
        var inputClass = this.showValidationError() ?
            "custom-control-input vehicle-details-radio form-control is-invalid" :
            "custom-control-input vehicle-details-radio";
        propertyTypes.forEach(function (type) {
            radioButtons.push(React.createElement("div", { className: "custom-control custom-radio specific-custom-radio" },
                React.createElement("input", { className: inputClass, type: "radio", name: "propertyType" + type.id, id: "propertyType" + type.id, value: type.id, disabled: _this.getSetting(services_1.INPUT_DISABLED_SETTING, false), onBlur: function (e) { return _this.validate(e); }, checked: _this.state.propertyType === type.id, onChange: _this.onPropertyTypeChange }),
                React.createElement("label", { className: "custom-control-label", htmlFor: "propertyType" + type.id }, type.value)));
        });
        return (React.createElement("div", { className: "form-group radio mb-30-mobile" },
            React.createElement("div", { className: "input-group width-auto pb-0", role: "group", "aria-label": "propertyType" }, radioButtons)));
    };
    AnnualHomePropertyTypeWidget.prototype.renderPropertySubtypes = function () {
        var _this = this;
        var propertySubTypes = this.state.propertySubTypes;
        var inputClass = this.showValidationError() ?
            "custom-control-input vehicle-details-radio form-control is-invalid" :
            "custom-control-input vehicle-details-radio";
        if (this.state.subTypesLoading) {
            return React.createElement(components_1.Overlay, { show: true });
        }
        else if (propertySubTypes.length > 0) {
            var radioButtons_1 = [];
            propertySubTypes.forEach(function (type) {
                radioButtons_1.push(React.createElement("div", { className: "custom-control custom-radio specific-custom-radio custom-radio-mobile-full-width" },
                    React.createElement("input", { className: inputClass, type: "radio", name: "propertySubType" + type.id, id: "propertySubType" + type.id, value: type.id, disabled: _this.getSetting(services_1.INPUT_DISABLED_SETTING, false), onBlur: function (e) { return _this.validate(e); }, checked: _this.state.propertyKind === type.id, onChange: _this.onPropertySubTypeChange }),
                    React.createElement("label", { className: "custom-control-label", htmlFor: "propertySubType" + type.id }, type.value)));
            });
            return (React.createElement("div", { className: "form-group radio mb-30-mobile" },
                React.createElement("label", null,
                    "What kind of ",
                    this.state.propertyType.toLowerCase(),
                    " is it?"),
                React.createElement("div", { className: "input-group width-auto pb-0", role: "group", "aria-label": "propertyType" }, radioButtons_1)));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    AnnualHomePropertyTypeWidget.prototype.onPropertyTypeChange = function (event) {
        var _this = this;
        var newValue = event.target.value;
        var noSubtypeOption = newValue === "OTHER" || newValue === "MOBILE_HOME" || newValue === "MAISONETTE" || newValue === "FARM_HOUSE" || newValue === "BEDSIT_HALLS";
        var fullValue = noSubtypeOption ? newValue + "_NO_OPTIONS" : undefined;
        this.setState({
            propertyType: newValue,
            propertyKind: undefined,
        }, function () { return _this.fetchPropertySubtypes(); });
        this.toggleExistingInsurance(newValue === "FLAT" || newValue === "MAISONETTE");
        if (newValue === "OTHER") {
            this.toggleHidePropertyTypeOtherWarning();
        }
        this.props.onStateChange("".concat(this.propertyTypeField), newValue);
        this.props.onStateChange("".concat(this.propertySubTypeField), undefined);
        this.props.onStateChange("".concat(this.props.question.interactionField), fullValue);
        this.validate(event);
        this.changelogRecorder.recordPage("change", this.props, this.props.question.interactionField);
    };
    AnnualHomePropertyTypeWidget.prototype.onPropertySubTypeChange = function (event) {
        var newValue = event.target.value;
        this.setState({
            propertyKind: newValue
        });
        if (newValue === "FLAT_NON_SELF_CONTAINED") {
            this.toggleHidePropertyKindNonSelfContainedFlatWarning();
        }
        this.props.onStateChange("".concat(this.propertySubTypeField), newValue);
        this.props.onStateChange("".concat(this.props.question.interactionField), newValue);
        this.validate(event);
        this.changelogRecorder.recordPage("change", this.props, this.props.question.interactionField);
    };
    AnnualHomePropertyTypeWidget.prototype.renderPropertyTypeOtherWarning = function () {
        var closeBtn = React.createElement("button", { className: "btn-close", onClick: this.toggleHidePropertyTypeOtherWarning });
        return (React.createElement(React.Fragment, null,
            React.createElement(reactstrap_1.Modal, { className: "my-2 info-modal", isOpen: this.state.showPropertyTypeOtherWarning, toggle: this.toggleHidePropertyTypeOtherWarning, backdrop: "static" },
                React.createElement(reactstrap_1.ModalHeader, { toggle: this.toggleHidePropertyTypeOtherWarning, close: closeBtn },
                    React.createElement("div", { className: "d-flex" },
                        React.createElement("img", { src: "/".concat(services_1.resourcesHelper.THEME, "/img/alert-blue.svg"), className: "fixed-alert-icon", alt: "warning-sign" }),
                        React.createElement("span", { className: "ml-3 text-blue-2 fs-20 font-weight-medium" }, "Sorry, we can't insure you because\u2026"))),
                React.createElement(reactstrap_1.ModalBody, { className: "font-family-base font-weight-extra-light" },
                    React.createElement("p", null, "We don't insure that type of property."),
                    React.createElement("p", null, "No worries though, our friends at Gallaghers might be able to help. You can contact them about their specialist insurance on: 0333 188 7823"),
                    React.createElement("p", null,
                        "Or you can take a look on the ",
                        React.createElement("a", { className: "text-decoration-underline text-blue-1", href: "https://www.biba.org.uk/find-insurance/", target: "_blank" }, "BIBA website"),
                        " to find providers who may offer cover.")),
                React.createElement(reactstrap_1.ModalFooter, { className: "d-flex flex-column" },
                    React.createElement(reactstrap_1.Button, { color: "btn btn-primary btn-add", className: "width-md-250 mb-1", onClick: this.toggleHidePropertyTypeOtherWarning }, "Ok, I understand")))));
    };
    AnnualHomePropertyTypeWidget.prototype.renderExistingInsuranceWarning = function () {
        return (React.createElement("div", { className: "banner banner-info", role: "alert" },
            React.createElement("p", null, "Before buying this policy, please make sure you don't have buildings insurance with anyone else (your management company, for example)")));
    };
    AnnualHomePropertyTypeWidget.prototype.renderPropertyKindNonSelfContainedFlatWarning = function () {
        var closeBtn = React.createElement("button", { className: "btn-close", onClick: this.toggleHidePropertyKindNonSelfContainedFlatWarning });
        return (React.createElement(React.Fragment, null,
            React.createElement(reactstrap_1.Modal, { className: "my-2 info-modal", isOpen: this.state.showPropertyKindNonSelfContainedFlatWarning, toggle: this.toggleHidePropertyKindNonSelfContainedFlatWarning, backdrop: "static" },
                React.createElement(reactstrap_1.ModalHeader, { toggle: this.toggleHidePropertyKindNonSelfContainedFlatWarning, close: closeBtn },
                    React.createElement("div", { className: "d-flex" },
                        React.createElement("img", { src: "/".concat(services_1.resourcesHelper.THEME, "/img/alert-blue.svg"), className: "fixed-alert-icon", alt: "warning-sign" }),
                        React.createElement("span", { className: "ml-3 text-blue-2 fs-20 font-weight-medium" }, "Sorry, we can't insure you because..."))),
                React.createElement(reactstrap_1.ModalBody, { className: "font-family-base font-weight-extra-light" },
                    React.createElement("p", null, "We don't insure that type of property."),
                    React.createElement("p", null, "No worries though, our friends at Gallaghers might be able to help. You can contact them about their specialist insurance on: 0333 188 7823"),
                    React.createElement("p", null,
                        "Or you can take a look on the ",
                        React.createElement("a", { className: "text-decoration-underline text-blue-1", href: "https://www.biba.org.uk/find-insurance/", target: "_blank" }, "BIBA website"),
                        " to find providers who may offer cover.")),
                React.createElement(reactstrap_1.ModalFooter, { className: "d-flex" },
                    React.createElement(reactstrap_1.Button, { className: "btn btn-primary btn-add width-md-250 mb-1", onClick: this.toggleHidePropertyKindNonSelfContainedFlatWarning }, "Ok, I understand")))));
    };
    AnnualHomePropertyTypeWidget.prototype.toggleHidePropertyTypeOtherWarning = function () {
        this.setState({ showPropertyTypeOtherWarning: !this.state.showPropertyTypeOtherWarning });
    };
    AnnualHomePropertyTypeWidget.prototype.toggleExistingInsurance = function (on) {
        this.setState({ showExistingInsuranceWarning: on });
    };
    AnnualHomePropertyTypeWidget.prototype.toggleHidePropertyKindNonSelfContainedFlatWarning = function () {
        this.setState({ showPropertyKindNonSelfContainedFlatWarning: !this.state.showPropertyKindNonSelfContainedFlatWarning });
    };
    AnnualHomePropertyTypeWidget.prototype.validate = function (event) {
        this.executeNativeEvent(event);
        this.validateInternal(event.target.value);
        return this.isValid();
    };
    ;
    AnnualHomePropertyTypeWidget.prototype.showValidationError = function () {
        var validationResult = this.props.validations[this.props.question.name];
        if (validationResult && !validationResult.valid) {
            return true;
        }
        return false;
    };
    AnnualHomePropertyTypeWidget.prototype.fetchPropertyTypes = function () {
        var _this = this;
        var fieldValue = this.getSetting("checkFieldValue") && this.propertyTypeField ? this.bindFromField(this.propertyTypeField) : undefined;
        this.lookupService.fetchLookupValues(this.propertyTypeLookup, "en-UK", fieldValue).subscribe(function (lookupValues) {
            _this.setState({
                propertyTypes: lookupValues
            });
        });
    };
    AnnualHomePropertyTypeWidget.prototype.fetchPropertySubtypes = function () {
        var _this = this;
        this.setState({ subTypesLoading: true });
        var fieldValue = this.getSetting("checkFieldValue") && this.props.question.interactionField ? this.bindFromField(this.props.question.interactionField) : undefined;
        this.lookupService.fetchLookupValues(this.propertySubTypeLookup, "en-UK", fieldValue).subscribe(function (lookupValues) {
            var _a;
            var subtypes = [];
            if (_this.state.propertyType) {
                subtypes = (_a = (lookupValues !== null && lookupValues !== void 0 ? lookupValues : []).filter(function (v) { return v.id.startsWith(_this.state.propertyType) && !v.id.endsWith("NO_OPTIONS"); })) !== null && _a !== void 0 ? _a : [];
            }
            _this.setState({
                propertySubTypes: subtypes
            });
        });
        this.setState({
            subTypesLoading: false
        });
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], AnnualHomePropertyTypeWidget.prototype, "changelogRecorder", void 0);
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.LookupService),
        __metadata("design:type", Object)
    ], AnnualHomePropertyTypeWidget.prototype, "lookupService", void 0);
    AnnualHomePropertyTypeWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: services_1.INPUT_DISABLED_SETTING, type: journey_model_1.TypeDescriptions.Boolean },
            { name: "propertyTypeField", type: journey_model_1.TypeDescriptions.String },
            { name: "propertySubTypeField", type: journey_model_1.TypeDescriptions.String },
            { name: "checkFieldValue", type: journey_model_1.TypeDescriptions.Boolean },
            { name: "hideDeclinePopUp", type: journey_model_1.TypeDescriptions.Boolean }
        ]),
        __metadata("design:paramtypes", [Object])
    ], AnnualHomePropertyTypeWidget);
    return AnnualHomePropertyTypeWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
//# sourceMappingURL=AnnualHomePropertyTypeWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/AnnualHomePropertyTypeWidget.js
// module id = 3681
// module chunks = 0